<template>

  <div :class="['settings']">
    <div class="columns is-multiline">
      <div v-if="getFieldType(k) !== 'Hidden'" class="column setting is-12-mobile is-half-tablet is-12-desktop" v-for="(v,k,i) in currentSettings" :key="k+i">
        <component :is="getFieldType(k)" :group="i" :value="currentSettings[k]" v-bind="getAttribute(k)" @changeAddons="UPDATE_ADDONS" @change="UPDATE_SETTING"></component>
      </div>      
    </div>

  </div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import draggable from 'vuedraggable'
import TextureSelectField from '@/components/fields/TextureSelectField.vue'
import AddonsSelector from '@/components/fields/AddonsSelector.vue'
import SwitchField from '@/components/fields/SwitchField.vue'
import Hidden from '@/components/fields/Hidden.vue'
import RangeSlider from '@/components/fields/RangeSlider.vue'

export default {

  name: 'Settings',

  props: ['settings'],

  computed:{

    ...mapGetters(['all_attributes', 'selectedItem', 'options']),

    currentSettings(){
      return this.selectedItem.settings;
    }

  },

  data:function(){
    return{
      
    }
  },

  mounted(){
     
  },

  components:{
    TextureSelectField,
    SwitchField,
    AddonsSelector,
    RangeSlider,
    Hidden,
    draggable
  },

  methods:{

    ...mapActions(['UPDATE_SETTING','UPDATE_ADDONS', 'EDIT_ITEM']),
  
    getAttribute(id){
      return this.all_attributes[id]
    },

    getFieldType(id){

      if(this.all_attributes[id] !== undefined){
        return this.all_attributes[id].fieldType;
      }else{
        return 'Hidden';
      }
      
    },


    closeSettings(){
      this.EDIT_ITEM({});
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.settings{
    position:relative;
    background:white;
    text-align: left;
    padding:1em;
}

.setting{
border-bottom:1px solid #ddd;
}

</style>